import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  analyticsLabelFromString,
  handleAdobeNavEvent,
} from '../../../helpers/adobe-analytics';

export class Homie extends Lit3formBlock {
  static get characterName() {
    return 'homie';
  }

  static get characterProperties() {
    return {
      headerText: { type: String },
      descriptionText: { type: String },
      imagesArr: { type: String },
    };
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div
          class="${classMap({
            'block-grid': true,
            'homie-layout': true,
            'has-images': !!this.imagesArr.length,
          })}"
        >
          <h2>${unsafeHTML(this.headerStr)}</h2>
          <p class="description">${unsafeHTML(this.descriptionStr)}</p>
          ${this.imagesWrapperHTML} ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  get imagesWrapperHTML() {
    return this.imagesArr.length
      ? html`
          <div class="images three-per-row">
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
        `
      : html``;
  }

  imageHTML(image) {
    return html`
      <div class="image-wrapper">
        <div class="image">
          ${!!image.url
            ? html`
                <a
                  href="${image.url}"
                  @click="${event => this.handleImageClick(image, event)}"
                >
                  <img src=${this.imageUrl(image)} />
                  <h3>${image.text}</h3>
                </a>
              `
            : html`
                <img src=${this.imageUrl(image)} />
              `}
        </div>
      </div>
    `;
  }

  imageUrl(img) {
    return this.imagebossUrl(img.src, 500, null);
  }

  handleImageClick(image, event) {
    handleAdobeNavEvent({
      navString: `NAV|${analyticsLabelFromString(
        this.headerStr || 'Homie'
      )}|${analyticsLabelFromString(image.text || image.url)}`,
      destinationUrl: image.url,
      event,
    });
  }

  get headerStr() {
    return this.withLineBreaks(this.content.header) || '';
  }

  get descriptionStr() {
    return this.withLineBreaks(this.content.description) || '';
  }
}
Homie.defineElement();
